import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ErrorDialogComponent } from '../../dialogs/error-dialog/error-dialog.component';
import { InfoDialogComponent } from '../../dialogs/info-dialog/info-dialog.component';
import { TipoMarcacaoEnum } from '../../enums/tipo-marcacao-enum';
import { RelatorioService } from '../../relatorio/comprovantes/relatorio-comprovante.service';
import { ServicosUtilidadesService } from '../../servicos-utilidades/servicos-utilidades.service';
import { MarcacaoComponent } from '../marcacao.component';

@Component({
  selector: 'app-marcacao-procedimento-realizado',
  templateUrl: './marcacao-procedimento-realizado.component.html',
  styleUrls: ['./marcacao-procedimento-realizado.component.css'],
})
export class MarcacaoProcedimentoRealizadoComponent
  extends MarcacaoComponent
  implements OnInit
{
  valorDoProcedimentoFormatado: string = '';

  temRecomendacoes: boolean = false;

  // Array de marcações quando vindo do fluxo em lote
  marcacoesProcedimento: Array<any> = [];

  constructor(
    router: Router,
    private relatorioService: RelatorioService,
    private dialog: MatDialog,
    private servicosUtilidadesService: ServicosUtilidadesService
  ) {
    super(router);
  }

  ngOnInit(): void {
    // Tenta ler a lista de marcações do state
    // Tenta ler a lista de marcações do state (router navigation state ou history.state como fallback)
    let navState: any = this.router.getCurrentNavigation()?.extras?.state;
    if (!navState) {
      // quando o usuário recarrega a página ou navega de forma que getCurrentNavigation() seja undefined,
      // ainda conseguimos recuperar o state via history.state (compatível com MarcacaoComponent)
      navState = history && history.state ? history.state : null;
    }
    console.log(
      'Número de marcações carregadas do state:',
      this.marcacoesProcedimento.length
    );
    // Em alguns cenários o state existe mas não contém a lista (ex.: submit anterior não incluiu ou foi vazio).
    if (
      navState &&
      navState.marcacoesProcedimento &&
      Array.isArray(navState.marcacoesProcedimento) &&
      navState.marcacoesProcedimento.length
    ) {
      this.marcacoesProcedimento = navState.marcacoesProcedimento;

      // Compatibilidade: se marcacaoProcedimento não foi setado, usa o primeiro da lista
      if (!this.marcacaoProcedimento && this.marcacoesProcedimento.length > 0) {
        this.marcacaoProcedimento = this.marcacoesProcedimento[0];
      }
    } else {
      console.log(
        'Nenhuma lista de marcações encontrada no state; fallback para marcacaoProcedimento único (se houver).'
      );
    }

    this.configurarTitulo('(Concluído)', TipoMarcacaoEnum.TIPO_MARCACAO_EXAME);

    // Valida se temos ao menos uma marcação com PK válida
    const todasMarcacoes = this.marcacoesProcedimento.length
      ? this.marcacoesProcedimento
      : [this.marcacaoProcedimento];

    const algumaInvalida = todasMarcacoes.some(
      (mp) =>
        !mp ||
        !mp.pk ||
        mp.pk.idPaciente == 0 ||
        mp.pk.idPlanoSaude == 0 ||
        !mp.pk.dataMarcacao ||
        mp.pk.idProcedimento == 0
    );

    if (algumaInvalida) {
      console.error('Marcação(ões) inválida(s), redirecionando para cadastro');

      this.router.navigate(['/marcacaoConsulta/cadastrarPaciente'], {
        state: {
          tipoMarcacao: 'TIPO_MARCACAO_EXAME',
        },
      });
      return;
    }

    // Envia SMS se necessário (compatibilidade com fluxo single)
    if (
      this.marcacaoProcedimento &&
      !this.marcacaoProcedimento.comprovanteSMSEnviadoAutomaticamente
    ) {
      /*
      if (environment.appAlias == 'COPE_AGENDA') {
        this.enviarComprovanteProcedimentoPorSMS();
      }
      */
    }

    // Verificar se algum procedimento tem recomendacoes
    this.temRecomendacoes = todasMarcacoes.some(
      (mp) =>
        mp?.procedimento?.recomendacoes != null &&
        mp.procedimento.recomendacoes !== ''
    );
  }

  onSubmit() {
    this.proximaTela();
  }

  proximaTela(): void {
    this.router.navigate(['/marcacaoConsulta/cadastrarPaciente'], {
      state: {
        tipoMarcacao: 'TIPO_MARCACAO_EXAME',
      },
    });
  }

  telaAnterior(): void {
    this.router.navigate(['/paginaInicial']);
  }

  enviarComprovantePorEmail(marcacao?: any): void {
    const mp = marcacao || this.marcacaoProcedimento;
    const lista =
      this.marcacoesProcedimento && this.marcacoesProcedimento.length
        ? this.marcacoesProcedimento
        : [mp];
    this.router.navigate(['/marcacaoConsulta/enviarComprovantePorEmail'], {
      state: {
        marcacaoProcedimento: mp,
        marcacoesProcedimento: lista,
        tipoMarcacao: 'TIPO_MARCACAO_EXAME',
      },
    });
  }

  enviarComprovantePorSMS(marcacao?: any): void {
    const mp = marcacao || this.marcacaoProcedimento;
    const lista =
      this.marcacoesProcedimento && this.marcacoesProcedimento.length
        ? this.marcacoesProcedimento
        : [mp];
    this.router.navigate(['/marcacaoConsulta/enviarComprovantePorSMS'], {
      state: {
        marcacaoProcedimento: mp,
        marcacoesProcedimento: lista,
        tipoMarcacao: 'TIPO_MARCACAO_EXAME',
      },
    });
  }

  imprimirComprovante(marcacao?: any): void {
    const mp = marcacao || this.marcacaoProcedimento;

    if (
      mp &&
      mp.pk &&
      mp.pk.idPaciente &&
      mp.pk.idPlanoSaude &&
      mp.pk.dataMarcacao &&
      mp.pk.idProcedimento
    ) {
      this.relatorioService
        .gerarComprovanteMarcacaoProcedimento(mp.pk, environment.appAlias)
        .subscribe((response: BlobPart) => {
          const file = new Blob([response], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);

          this.dialog.open(InfoDialogComponent, {
            data: {
              title: 'Info',
              message: 'Impressão realizada com sucesso!',
            },
          });
        });
    } else {
      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message:
            'Não foi possível imprimir o comprovante. Marcação não encontrada!',
        },
      });
    }
  }

    imprimirComprovantes(): void {

  const marcacoes= this.marcacoesProcedimento.map(mp => mp.pk);
      this.relatorioService
        .gerarComprovanteMarcacaoProcedimentos(marcacoes, environment.appAlias)
        .subscribe((response: BlobPart) => {
          const file = new Blob([response], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);

          this.dialog.open(InfoDialogComponent, {
            data: {
              title: 'Info',
              message: 'Impressão realizada com sucesso!',
            },
          });
        });
    
  }

  marcarOutroExame(): void {
    this.restaurarMarcacaoConsultaApartirDaTelaDeSelecaoDeExames();

    this.router.navigate(['/marcacaoConsulta/selecionarExame'], {
      state: { marcacaoConsulta: this.marcacaoConsulta },
    });
  }

  enviarComprovanteProcedimentoPorSMS(): void {
    if (
      this.marcacaoProcedimento &&
      this.marcacaoProcedimento.pk &&
      this.marcacaoProcedimento.pk.idPaciente &&
      this.marcacaoProcedimento.paciente &&
      this.marcacaoProcedimento.paciente.foneCelular
    ) {
      this.marcacaoProcedimento.comprovanteSMSEnviadoAutomaticamente = true;

      let local: string = this.getUnidade(
        this.marcacaoProcedimento.planoSaude.nome
      );

      this.servicosUtilidadesService
        .enviarSMSAgendamentoProcedimento(
          this.marcacaoProcedimento,
          this.marcacaoProcedimento.paciente.foneCelular,
          environment.appAlias,
          local
        )
        .subscribe(
          (data) => {
            //console.log(data);
          },
          (error) => {
            console.log(error);
          }
        );
    }
  }

  baixarRecomendacoesDoExame(marcacao?: any): void {
    // Se não recebeu marcação específica, usa a primeira/única
    const mp = marcacao || this.marcacaoProcedimento;

    if (
      mp &&
      mp.pk &&
      mp.pk.idFilial &&
      mp.pk.idPaciente &&
      mp.pk.idPlanoSaude &&
      mp.pk.dataMarcacao &&
      mp.pk.idProcedimento &&
      mp.procedimento &&
      mp.procedimento.recomendacoes
    ) {
      this.relatorioService
        .gerarRecomendacoesMarcacaoProcedimento(mp.pk)
        .subscribe((response: BlobPart) => {
          const file = new Blob([response], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        });
    } else {
      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message:
            'Não foi possível baixar as recomendações desse exame. Marcação / Recomendação não encontrada!',
        },
      });
    }
  }

  getUnidade(nomePlanoSaude: string): string {
    return environment.appAlias != 'COPE_AGENDA' ? nomePlanoSaude : 'Boa Vista';
  }
}
